import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsletterStrip from "../components/NewsletterStrip";
import { DealCard } from "../components/ContentCards";

export default function DealsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/deals?status=published&limit=50").then((r) => setItems(r.data.items));
  }, []);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20">
        <div className="overline text-[#B4533C]">Deal Alerts</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-2">Live travel deals</h1>
        <p className="mt-4 text-[#4A4742] max-w-2xl">Hand-picked flight, hotel, and points sweet spots. We remove them when they expire.</p>
      </div>
      <div className="container-page pb-20">
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((d) => <DealCard key={d.id} deal={d} />)}
        </div>
        {items.length === 0 && <div className="text-sm font-mono text-[#4A4742]">No live deals right now.</div>}
      </div>
      <NewsletterStrip />
      <Footer />
    </div>
  );
}
